var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"c2b-loading"},[_c('fa',{staticClass:"c2b-loading-icon",attrs:{"icon":"sync-alt","spin":""}}),(!!_vm.message)?_c('span',{staticClass:"c2b-loading-message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }